/**
 * 清除 document 中所有以 _ 开头的 cookie。
 * 本项目使用 JWT (Bearer Token) 认证，不使用 cookie，
 * 因此所有请求默认需将 _ 开头的 cookie 参数移除。
 */
export const clearUnderscoreCookies = (): void => {
  if (typeof document === 'undefined') return

  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0]?.trim()
    if (name && name.startsWith('_')) {
      // 清除当前 domain 下所有 path 的 cookie
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
      // 也尝试清除根 path 上的
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`
    }
  })
}
